export default "__VITE_ASSET__6d554ee3__"